import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-22d4aaea"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "main"
};
const _hoisted_2 = {
  class: "sel-main"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 硬件型号 ");

const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "sel-main"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 操作系统版本 ");

const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "sel-main"
};

const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 设备配置 ");

const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "sel-main"
};

const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Android ID ");

const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "sel-main"
};

const _hoisted_15 = /*#__PURE__*/_createTextVNode(" OAID ");

const _hoisted_16 = ["src"];
const _hoisted_17 = {
  class: "sel-main"
};

const _hoisted_18 = /*#__PURE__*/_createTextVNode(" IMEI ");

const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "sel-main"
};

const _hoisted_21 = /*#__PURE__*/_createTextVNode(" MAC地址 ");

const _hoisted_22 = ["src"];
const _hoisted_23 = {
  class: "sel-main"
};

const _hoisted_24 = /*#__PURE__*/_createTextVNode(" idfv ");

const _hoisted_25 = ["src"];
const _hoisted_26 = {
  class: "sel-main"
};

const _hoisted_27 = /*#__PURE__*/_createTextVNode(" idfa ");

const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "sel-main"
};

const _hoisted_30 = /*#__PURE__*/_createTextVNode(" ICCID ");

const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "sel-main"
};

const _hoisted_33 = /*#__PURE__*/_createTextVNode(" BSSID ");

const _hoisted_34 = ["src"];
const _hoisted_35 = {
  class: "sel-main"
};

const _hoisted_36 = /*#__PURE__*/_createTextVNode(" SSID ");

const _hoisted_37 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_top_title = _resolveComponent("top-title");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_top_title, {
    onBack: $setup.back,
    title: "设备属性信息"
  }, null, 8, ["onBack"]), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[0] || (_cache[0] = $event => $setup.router.push({
      'name': 'CollectDeviceNumber'
    }))
  }, [_hoisted_3, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_4)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[1] || (_cache[1] = $event => $setup.router.push({
      'name': 'CollectDeviceSystem'
    }))
  }, [_hoisted_6, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_7)])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[2] || (_cache[2] = $event => $setup.router.push({
      'name': 'CollectDeviceConfig'
    }))
  }, [_hoisted_9, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_10)])]), _createElementVNode("div", _hoisted_11, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[3] || (_cache[3] = $event => $setup.router.push({
      'name': 'CollectDeviceAndroid'
    }))
  }, [_hoisted_12, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_13)])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[4] || (_cache[4] = $event => $setup.router.push({
      'name': 'CollectDeviceOaid'
    }))
  }, [_hoisted_15, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_16)])]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[5] || (_cache[5] = $event => $setup.router.push({
      'name': 'CollectDeviceImei'
    }))
  }, [_hoisted_18, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_19)])]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[6] || (_cache[6] = $event => $setup.router.push({
      'name': 'CollectDeviceMac'
    }))
  }, [_hoisted_21, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_22)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[7] || (_cache[7] = $event => $setup.router.push({
      'name': 'CollectDeviceIdfv'
    }))
  }, [_hoisted_24, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_25)])]), _createElementVNode("div", _hoisted_26, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[8] || (_cache[8] = $event => $setup.router.push({
      'name': 'CollectDeviceIdfa'
    }))
  }, [_hoisted_27, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_28)])]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[9] || (_cache[9] = $event => $setup.router.push({
      'name': 'CollectDeviceIccid'
    }))
  }, [_hoisted_30, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_31)])]), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[10] || (_cache[10] = $event => $setup.router.push({
      'name': 'CollectDeviceBssid'
    }))
  }, [_hoisted_33, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_34)])]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", {
    class: "sel-item",
    onClick: _cache[11] || (_cache[11] = $event => $setup.router.push({
      'name': 'CollectDeviceSsid'
    }))
  }, [_hoisted_36, _createElementVNode("img", {
    src: $setup.Right,
    class: "right-icon"
  }, null, 8, _hoisted_37)])])]);
}